import 'isomorphic-fetch';

interface FetchOwnersManualTokenProps {
  readonly faServicesUrl: string;
  readonly apiKey: string;
  readonly vin: string;
  readonly serviceConfigsServiceConfig?: string
}

export const fetchOwnerManualToken = async ({
  faServicesUrl,
  apiKey,
  vin,
  serviceConfigsServiceConfig
}: FetchOwnersManualTokenProps): Promise<{ token: string }> => {
  const params = new URLSearchParams();

  if (vin) params.set('vin', vin);

  if (serviceConfigsServiceConfig) {
    params.set('serviceConfigsServiceConfig', serviceConfigsServiceConfig);
  }

  const url: string = `${faServicesUrl}/maintenance/owners-token?${params.toString()}`;

  const response = await fetch(url, {
    headers: { 'x-api-key': apiKey }
  });

  if (response.status >= 400) {
    throw new Error(`Failed to fetch owner's manual token: ${response.status} ${response.statusText}`);
  }

  const data = await response.json();

  return data;
};